import PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";
import { fDateTimeWithTimezone } from "../../../../../utils/formatTime";

OrderLogView.propTypes = {
  logItem: PropTypes.object,
}
export default function OrderLogView({logItem}) {
  return <Box>
    <Typography variant="body" color="info.main" sx={{wordBreak: 'break-word', whiteSpace: 'normal'}}>
      Order viewed by {logItem.viewedBy}
    </Typography>
    <Typography variant="body2" color="black">
      {fDateTimeWithTimezone(logItem.dateAdded)}
    </Typography>
  </Box>        
}